export const animations = {
  big: { spine: 'animations/spine/win/popups/skeleton.json' },
  mega: { spine: 'animations/spine/win/popups/skeleton.json' },
  ultra: { spine: 'animations/spine/win/popups/skeleton.json' },
  multiply: { spine: 'animations/spine/win/x2/skeleton.json' },
}

export const time = 1.5
